/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
import { useRef, useState } from 'react';
/** Goldspot imports */

/**
 * Tracks state of multiple async processes at once
 * @returns
 */
export const useWaiting = () => {
  const [waiting, setWaiting] = useState<boolean>(false);
  const pendingProcesses = useRef<string[]>([]);

  const getNewReferenceId = (): string => {
    const now: Date = new Date();
    const processReferenceId: string = `process_${now.valueOf()}_${
      1000 * Math.random()
    }`;
    return processReferenceId;
  };

  /**
   * Adds a process to the state tracking
   * @returns a reference id string to use with `stopTrackingProcess` when process is complete
   */
  const startTrackingProcess = (): string => {
    const newReferenceId: string = getNewReferenceId();
    pendingProcesses.current.push(newReferenceId);
    if (!waiting) {
      setWaiting(true);
    }
    return newReferenceId;
  };

  /**
   * Updates process tracking state when a process is done
   * @param processReferenceId string returned by `startTrackingProcess`
   */
  const stopTrackingProcess = (processReferenceId: string): void => {
    const processIndex: number =
      pendingProcesses.current.indexOf(processReferenceId);
    pendingProcesses.current.splice(processIndex, 1);
    if (pendingProcesses.current.length === 0) {
      setWaiting(false);
    }
  };

  return {
    waiting,
    startTrackingProcess,
    stopTrackingProcess,
  };
};
